export function getNoteCreatedTime(note) {
  const date = new Date(note.createdTime)
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
}
